// 首字大写
export const upperFirstChat = name => name[0].toUpperCase() + name.slice(1)

/**
 * 插入script在页面
 * @param url
 */
export const loadScript = url => {
  window.loadedScript = window.loadedScript || []
  return new Promise(resolve => {
    if (window.loadedScript.includes(url)) {
      resolve({
        code: 1,
        msg: 'this script was loaded'
      })
    }
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)

    script.onload = function () {
      script.onload = null
      window.loadedScript.push(url)
      resolve({
        code: 1,
        msg: 'script load success!'
      })
    }
  })
}
// 输入秒数，转换成 mm:ss的格式
export const secondToTime = second => {
  if (!second) return `00:00`
  let sec = padZero(Math.floor(second) % 60, 2)
  let minute = padZero(Math.floor(second / 60).toFixed(0), 2)
  return `${minute}:${sec}`
}
/**
 * 数字补0
 * @param num
 * @param length
 * @returns {string}
 */
export const padZero = (num, length) => {
  return (Array(length).join('0') + num).slice(-length)
}
export const setScrollTop = number => {
  if (typeof (number * 1) == 'number') {
    if (
      document.documentElement &&
      document.documentElement.scrollTop !== undefined
    ) {
      document.documentElement.scrollTop = number
    }
    if (document.body && document.body.scrollTop !== undefined) {
      document.body.scrollTop = number
    }
  } else {
    console.error('设置scrollTop传入的值不是数字')
  }
}
/**
 * 将毫秒转为分'秒"
 * @param mss 毫秒
 * @param minutesSign 分标志默认'
 * @param secondsSign 秒标志 默认"
 * @returns {string} minutes'seconds''
 */
export const formatDuring = (mss, minutesSign = `'`, secondsSign = `"`) => {
  if (!mss) return '0'
  // let days = parseInt(mss / (1000 * 60 * 60 * 24));
  // let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
  let seconds = Math.round((mss % (1000 * 60)) / 1000)
  return `${padZero(minutes, 2)}${minutesSign}${padZero(
    seconds,
    2
  )}${secondsSign}`
}
/**
 * 将秒转为时分秒
 * @param  s 秒
 * @param hSign 时标志默认:
 * @param mSign 分标志默认:
 * @param needHour 是否需要小时
 */
export const secondsFormat = (s, hSign = ':', mSign = ':', needHour = true) => {
  let day = Math.floor(s / (24 * 3600)) // Math.floor()向下取整
  let hour = Math.floor((s - day * 24 * 3600) / 3600)
  let minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60)
  let second = Math.round(s - day * 24 * 3600 - hour * 3600 - minute * 60)
  let hourStr = padZero(hour, 2) + hSign
  if (!needHour) {
    hourStr = ''
  }
  return hourStr + padZero(minute, 2) + mSign + padZero(second, 2)
}
/**
 * 将00:30.00转为秒单位
 * @param time 时间 格式 分 : 秒 . 毫秒
 * @returns {number} 秒
 */
export const formatTimeToDuring = time => {
  if (!time || typeof time !== 'string') return 0
  const m = time.split(':')[0] * 1
  const s = time.split(':')[1].split('.')[0] * 1
  return m * 60 + s
}
/**
 * 把json转为表单形式 一维数组对象
 * @param arr 要转的数组  [url,url]
 * @param objName 要转为的对象名称
 * return demo objName[0].a=1,objName[0].a=2
 * */
export const obj2FormObjForOneDimen = (arr, objName) => {
  let newObj = {}
  for (let a = 0; a < arr.length; a++) {
    newObj[objName + '[' + a + ']'] = arr[a]
  }
  return newObj
}
// 比较手机版本号方法
//假定字符串的每节数都在5位以下
export const toVersion = v => {
  let version = v.toString()
  //也可以这样写 var c=a.split(/\./);
  let c = version.split('.')
  let num_place = ['', '0', '00', '000', '0000'],
    r = num_place.reverse()
  for (let i = 0; i < c.length; i++) {
    let len = c[i].length
    c[i] = r[len] + c[i]
  }
  return c.join('')
}

/**
 * 检测类型
 * @param {any} target 检测的目标
 * @returns {'string'|'number'|'array'|'object'|'function'|'null'|'undefined'|'regexp'} 只枚举一些常用的类型
 */
export const checkType = target => {
  /** @type {string} */
  const value = Object.prototype.toString.call(target)
  const result = value.match(/\[object (\S*)\]/)[1]
  return result.toLocaleLowerCase()
}

/**
 * 格式化日期
 * @param {string | number | Date} value 指定日期
 * @param {string} format 格式化的规则
 * @example
 * ```js
 * formatDate();
 * formatDate(1603264465956);
 * formatDate(1603264465956, 'h:m:s');
 * formatDate(1603264465956, 'Y-M-D');
 * formatDate(1603264465956, 'Y年-M月-D日');
 * ```
 */
export const formatDate = (value = Date.now(), format = 'Y-M-D h:m:s') => {
  if (!value) return '-'
  const formatNumber = n => `0${n}`.slice(-2)
  // ios 下，带横杆的字符串日期是格式不了的，这里做一下判断处理
  if (checkType(value) === 'string' && new Date(value) == 'Invalid Date') {
    value = value.replace(/-/g, '/')
  }
  const date = new Date(value)
  const formatList = ['Y', 'M', 'D', 'h', 'm', 's']
  const resultList = []
  resultList.push(date.getFullYear().toString())
  resultList.push(formatNumber(date.getMonth() + 1))
  resultList.push(formatNumber(date.getDate()))
  resultList.push(formatNumber(date.getHours()))
  resultList.push(formatNumber(date.getMinutes()))
  resultList.push(formatNumber(date.getSeconds()))
  for (let i = 0; i < resultList.length; i++) {
    format = format.replace(formatList[i], resultList[i])
  }
  return format
}

export const forDate = val => {
  if (!val) return
  let currentTime = new Date().getTime()
  let createTime = new Date(val).getTime()
  let differ = currentTime - createTime
  let min = differ / 1000 / 60
  let hours = min / 60
  let days = hours / 24
  if (min < 3) {
    return '刚刚'
  } else if (min > 3 && hours < 1) {
    return Math.floor(min) + '分钟前'
  } else if (hours > 1 && hours < 24) {
    return Math.floor(hours) + '小时前'
  } else if (hours > 24 && hours < 96) {
    return Math.floor(days) + '天前'
  } else {
    return formatDate(val, 'Y.M.D')
  }
}

// html文本内容编译
export const htmlDecode = input => {
  const entities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x2F;': '/'
  }

  for (let prop in entities) {
    if (entities.hasOwnProperty(prop)) {
      input = input.replace(new RegExp(prop, 'g'), entities[prop])
    }
  }
  return input.replace(/\n/g, '</br>')
}
